import { Button, InputLabel, MenuItem, Select } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import TextFields from "../../../components/TextField";
import useOpeningStock from "./hooks/useOpeningStock";
import Modal from "../../../components/Modal";
import MultipleSelect from "../../../components/MultipleSelect";
import AddCircleIcon from "@mui/icons-material/AddCircle";
const AddOpeningStock = () => {
  const navigate = useNavigate();
  const { data, methods } = useOpeningStock();
  const {
    unitsList,
    categoryList,
    vendorList,
    formData,
    categoryModal,
    vendorModal,
    formDataCategory,
    formDataVendor,
    formError,
    isEditMode,
    errorVendor,
    errorCategory
  } = data;
  const {
    handleChange,
    inventoryAdd,
    handleCloseCategroyModal,
    handleOpenCategroyModal,
    handleCloseVendorModal,
    handleOpenVendorModal,
    addCategory,
    addVendor,
    handleChangeCategory,
    handleChangeVendor,
    inventoryUpdate,
    setFormData,
    setFormError,
  } = methods;

  return (
    <>
      <ToastContainer />
      {/* {spinner && <Spinner />} */}
      <div className="contact">
        <div className="container bg">
          <div className="col-lg-11 mx-auto">
            <div className="row">
              <div className="text-center pt-3">
                <h4> {isEditMode ? "Update Inventory" : "Add Inventory"}</h4>
              </div>

              <TextFields
                Lable="Product Name"
                Name="productName"
                variant="outlined"
                ClassName="form-field-design"
                HandleInputChange={handleChange}
                Value={formData.productName}
                width={100}
              />

              {/* <div className="col-lg-6 pt-2">
                <InputLabel id="category-select-label">
                  Category <span className="text-danger">*</span>
                </InputLabel>
                <Select
                  labelId="category-select-label"
                  id="category-select"
                  name="category"
                  value={formData.category}
                  onChange={handleChange}
                  style={{ height: "35px", width: "100%" }}
                  error={formError?.category}
                  required={true}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 200,
                      },
                    },
                    MenuListProps: {
                      sx: {
                        py: 0,
                      },
                    },
                  }}
                >
                  <MenuItem
                    value=""
                    onClick={handleOpenCategroyModal}
                    style={{ fontWeight: "700" }}
                  >
                    Add Category{" "}
                    <AddCircleIcon
                      color="primary"
                      fontSize="30x"
                      style={{ marginInline: "5px" }}
                    />
                  </MenuItem>
                  {categoryList.map((item) => (
                    <MenuItem value={item?._id} key={item?._id}>
                      {item?.name}
                    </MenuItem>
                  ))}
                </Select>
                {formError.category && (
                  <small className="text-danger">{formError.category}</small>
                )}

              </div> */}

              <div className="col-lg-6 pt-2">
                <div className="d-flex justify-content-between align-items-center">
                  <InputLabel
                    id="category-select-label"
                    sx={{ fontSize: "13px" }}
                  >
                    Category <span className="text-danger">*</span>
                  </InputLabel>
                  <div
                    className="d-flex gap-1 cursor-pointer"
                    onClick={handleOpenCategroyModal}
                  >
                    <span className="fw-ligher">Add Categeory</span>
                    <AddCircleIcon
                      color="primary"
                      fontSize="medium"
                      style={{ cursor: "pointer" }}
                    />
                  </div>
                </div>

                <MultipleSelect
                  options={categoryList.map((item) => ({
                    id: item._id,
                    name: item.name,
                  }))}
                  searchBy="name"
                  keyName="name"
                  name="category"
                  value="id"
                  error={formError?.category}
                  selectedValues={
                    formData.category
                      ? [
                          {
                            id: formData.category,
                            name:
                              categoryList.find(
                                (x) => x._id === formData.category
                              )?.name || "",
                          },
                        ]
                      : []
                  }
                  onChange={(selected) => {
                    const newValue = selected.length > 0 ? selected[0].id : "";
                    setFormData((prev) => ({ ...prev, category: newValue }));

                    if (newValue) {
                      setFormError((prev) => ({ ...prev, category: "" }));
                    }
                  }}
                />
              </div>

              {/* <div className="col-lg-6 pt-2">
                <InputLabel id="vendor-select-label">
                  Vendor <span className="text-danger">*</span>
                </InputLabel>
                <Select
                  labelId="vendor-select-label"
                  id="vendor-select"
                  name="vendor"
                  value={formData.vendor}
                  onChange={handleChange}
                  error={formError?.vendor}
                  required={true}
                  style={{ height: "35px", width: "100%" }}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 200,
                      },
                    },
                    MenuListProps: {
                      sx: {
                        py: 0,
                      },
                    },
                  }}
                >
                  <MenuItem
                    value=""
                    onClick={handleOpenVendorModal}
                    style={{ fontWeight: "700" }}
                  >
                    Add vendor{" "}
                    <AddCircleIcon
                      color="primary"
                      fontSize="30x"
                      style={{ marginInline: "5px" }}
                    />
                  </MenuItem>
                  {vendorList.map((item) => (
                    <MenuItem value={item?._id} key={item?._id}>
                      {item?.name}
                    </MenuItem>
                  ))}
                </Select>
                {formError.vendor && (
                  <small className="text-danger">{formError.vendor}</small>
                )}
              </div> */}
              <div className="col-lg-6 pt-2">
                <div className="d-flex justify-content-between align-items-center">
                  <InputLabel
                    id="vendor-select-label"
                    sx={{ fontSize: "13px" }}
                  >
                    Vendor <span className="text-danger">*</span>
                  </InputLabel>

                  <div
                    className="d-flex gap-1 cursor-pointer"
                    onClick={handleOpenVendorModal}
                  >
                    <span className="fw-ligher">Add Vendor</span>
                    <AddCircleIcon
                      color="primary"
                      fontSize="medium"
                      style={{ cursor: "pointer" }}
                    />
                  </div>
                </div>

                <MultipleSelect
                  options={vendorList.map((item) => ({
                    id: item._id,
                    name: item.name,
                  }))}
                  searchBy="name"
                  keyName="name"
                  name="vendor"
                  value="id"
                  error={formError?.vendor}
                  selectedValues={
                    formData.vendor
                      ? [
                          {
                            id: formData.vendor,
                            name:
                              vendorList.find((x) => x._id === formData.vendor)
                                ?.name || "",
                          },
                        ]
                      : []
                  }
                  onChange={(selected) => {
                    const newValue = selected.length > 0 ? selected[0].id : "";
                    setFormData((prev) => ({ ...prev, vendor: newValue }));

                    if (newValue) {
                      setFormError((prev) => ({ ...prev, vendor: "" }));
                    }
                  }}
                />
              </div>

              <div className="col-lg-6 pt-2">
                <TextFields
                  Lable="Price"
                  Name="price"
                  type="number"
                  variant="outlined"
                  ClassName="form-field-design"
                  HandleInputChange={handleChange}
                  Value={formData.price}
                  width={100}
                />
              </div>

              <div className="col-lg-6 pt-2">
                <TextFields
                  Lable="Purchase Price"
                  Name="purchasePrice"
                  type="number"
                  variant="outlined"
                  ClassName="form-field-design"
                  HandleInputChange={handleChange}
                  Value={formData.purchasePrice}
                  width={100}
                />
              </div>

              <div className="col-lg-6 pt-2">
                <MultipleSelect
                  label="Unit"
                  options={unitsList}
                  searchBy="name"
                  keyName="name"
                  name="units"
                  value="id"
                  isRequired={true}
                  error={formError?.units}
                  selectedValues={
                    formData.units
                      ? [{ id: formData.units, name: formData.units }]
                      : []
                  }
                  onChange={(selected) => {
                    const newValue = selected.length > 0 ? selected[0].id : "";

                    setFormData((prev) => ({
                      ...prev,
                      units: newValue,
                    }));
                    if (newValue) {
                      setFormError((prev) => ({
                        ...prev,
                        units: "",
                      }));
                    }
                  }}
                />
              </div>
              <div className="col-lg-6 pt-2">
                <TextFields
                  Lable="Minimum Stock Level"
                  Name="minimumQuantityLevel"
                  variant="outlined"
                  type="number"
                  ClassName="form-field-design"
                  HandleInputChange={handleChange}
                  Value={formData.minimumQuantityLevel}
                  width={100}
                />
              </div>

              <div className="col-lg-6 pt-2">
                <TextFields
                  Lable="Quantity"
                  Name="quantity" // Fixed: Changed from "name" to "quantity"
                  variant="outlined"
                  type="number"
                  ClassName="form-field-design"
                  HandleInputChange={handleChange}
                  Value={formData.quantity}
                  width={100}
                />
              </div>

              <div className="col-lg-12 my-2 pe-4">
                <div className=" d-flex justify-content-end ">
                  <div className="m-2">
                    <Button
                      variant="outlined"
                      onClick={() => navigate("/setting/opening-stock")}
                    >
                      Cancel
                    </Button>
                  </div>

                  <div className="m-2">
                    {isEditMode ? (
                      <Button variant="contained" onClick={inventoryUpdate}>
                        Update
                      </Button>
                    ) : (
                      <Button variant="contained" onClick={inventoryAdd}>
                        Create
                      </Button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal
        size="md"
        show={categoryModal}
        onHide={handleCloseCategroyModal}
        headerContent={<h5>Add category</h5>}
        bodyContent={
          <div className="">
            <TextFields
              Lable="Name"
              Name="name"
              variant="outlined"
              Error={errorCategory.name}
              Require={true}
              ClassName="form-field-design"
              HandleInputChange={handleChangeCategory}
              Value={formDataCategory.name}
              width={100}
            />
            <div className="d-flex justify-content-end mt-4">
              <Button variant="contained" onClick={handleCloseCategroyModal}>
                cancel
              </Button>
              <Button
                onClick={addCategory}
                variant="outlined"
                className="ms-2"
                data-bs-dismiss="modal"
              >
                Add
              </Button>
            </div>
          </div>
        }
      />

      <Modal
        size="md"
        show={vendorModal}
        onHide={handleCloseVendorModal}
        headerContent={<h5>Add vendor</h5>}
        bodyContent={
          <div className="">
            <div className="row">
              <div className="pt-2">
                <TextFields
                  Lable="Vendor"
                  Name="name"
                  Require={true}
                 Error={errorVendor.name} 
                  variant="outlined"
                  ClassName="form-field-design"
                  HandleInputChange={handleChangeVendor}
                  Value={formDataVendor.name}
                  width={100}
                />
              </div>
              <div className="pt-2">
                <TextFields
                  Lable="GST Number"
                  Name="gstNumber"
                  variant="outlined"
                  ClassName="form-field-design"
                  HandleInputChange={handleChangeVendor}
                  Value={formDataVendor.gstNumber}
                  width={100}
                />
              </div>
              <div className="pt-2">
                <TextFields
                  Lable="Address"
                  Name="address"
                  variant="outlined"
                  ClassName="form-field-design"
                  HandleInputChange={handleChangeVendor}
                  Value={formDataVendor.address}
                  width={100}
                />
              </div>
            </div>

            <div className="d-flex justify-content-end mt-4">
              <Button variant="outlined" onClick={handleCloseVendorModal}>
                cancel
              </Button>
              <Button
                onClick={addVendor}
                variant="contained"
                className="ms-2"
                data-bs-dismiss="modal"
              >
                Add
              </Button>
            </div>
          </div>
        }
      />
    </>
  );
};

export default AddOpeningStock;
